/**
 * Situational Awareness (SA) topic manager.
 *
 * Handles messages on the "sa" namespace:
 *   - "updated"  -> upsert entity on the map
 *   - "position" -> upsert entity on the map
 *   - "deleted"  -> remove entity from the map
 *
 * Incoming payloads are CoT protobuf binaries which are decoded
 * via cotUtils before being dispatched to the Redux map slice.
 */

import { TopicManager } from "../types";
import { AppDispatch } from "../../../store";
import { mapSlice } from "../../../components/map/mapSlice";
import { parseCotMessage, cotToMapEntity } from "../../../utils/cotUtils";

export class SituationAwarenessManager implements TopicManager {
    constructor(private dispatch: AppDispatch) {}

    handleMessage(eventType: string, payload: Buffer): void {
        const parsed = parseCotMessage(new Uint8Array(payload));
        console.log("[MQTT sa/" + eventType + "] parsed CoT:", parsed);
        if (!parsed) return;

        switch (eventType) {
            case "deleted":
                this.dispatch(mapSlice.actions.removeEntity(parsed.uid));
                break;
            case "updated":
            case "position": {
                const entity = cotToMapEntity(parsed);
                console.log("[MQTT sa/" + eventType + "] MapEntity:", entity);
                if (entity) {
                    this.dispatch(mapSlice.actions.addEntity(entity));
                }
                break;
            }
        }
    }
}
